import dynamic from 'next/dynamic';
import { Builder } from '@builder.io/sdk';
import { IconCardInputs } from '../IconCard/IconCard.config';

const IconCardRow = dynamic(() => import('./IconCardRow'));

const IconCardRowConfig = {
  name: 'IconCardRow',
  friendlyName: 'Icon Card Row',
  inputs: [
    {
      name: 'items',
      type: 'list',
      subFields: [...IconCardInputs],
    },
  ],
};

Builder.registerComponent(IconCardRow, IconCardRowConfig);
